{
  "all-listings": {
    "disconnected": {
      "text": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans le réseau Partage Agricole."
    },
    "needLogin": {
      "secondLine": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans le réseau Partage Agricole."
    },
    "empty": {
      "offer": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Publie une offre !",
        "secondLine": "Participe au catalogue en offrant des objets à prêter."
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "Tu aimes ce que tu vois? Retrouve Partage Agricole sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Partage Agricole"
    }
  },
  "contact-information": {
    "prompt": "Ajoutez le code postal de l'entreprise afin de voir quels objets sont disponibles à proximité.",
    "title": "Votre adresse",
    "prompt-public": "Ajoutez votre code postal afin de voir les annonces disponibles à proximité.",
    "title-public": "Ton code postal"
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres de Partage Agricole est accessible par courriel et messagerie. Nous te répondrons le plus rapidement possible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "Salut\u00A0!\u00A0😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Salut\u00A0!\u00A0😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci\u00A0!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Seuls les partenaires de Partage Agricole peuvent utiliser cette application. Pour obtenir le code d'invitation, contactez <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser Partage Agricole pour vendre des objets."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Partage Agricole",
        "title": "Explorateur"
      }
    }
  },
  "introModal": {
    "title": "Cher {{name}},",
    "first": "Merci de rejoindre la communauté et faire un premier pas vers la réduction de ta consommation et la création de nouveaux liens !",
    "second": "<strong>Partager est une preuve de confiance</strong> : plus vous prêtez, plus les autres auront envie de vous prêter !",
    "third": "<strong>Sache que moins de 0,1% de tous les partages</strong> engendrent un bris. Et ce n’est pas de mauvaise foi. C’est juste normal quand les objets sont un peu plus utilisés."
  },
  "my-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "credentialInformationTitle": "Compte et sécurité",
    "personalInformationTitle": "Informations du profil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "firstNameFieldPlaceholder": "ex. Ferme de la Tour d'Argent",
    "title": "Informations du profil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Votre abonnement à cette application de mutualisation est une gracieuseté de Partage Agricole."
      },
      "title": {
        "enterprise": "Abonnement Partage Agricole"
      }
    },
    "noEnd": "Cet abonnement est valide tant que vous êtes membre Partage Agricole."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Tracteur de jardin",
      "descriptionFieldPlaceholder": {
        "offer": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ...",
        "request": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvre Partage Agricole !"
      }
    },
    "welcome": "Bienvenue sur Partage Agricole !",
    "welcomeMessage": "Merci de nous faire confiance.",
    "rate": {
      "borrower": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partage Agricole."
      },
      "lender": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partage Agricole."
      }
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Cher membre,",
      "text": {
        "lender": {
          "before": "N’oubliez pas de réserver vos dates de travaux et planifier vos journées de transport lors de votre réservation.",
          "after": "N’oubliez pas de réserver vos dates de travaux et planifier vos journées de transport."
        },
        "borrower": "N’oubliez pas de planifier vos journées de transport lors de votre emprunt."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "firstNameFieldPlaceholder": "ex. Ferme de la Tour d'Argent",
    "pictureFieldSubtitle": "Cette image sera affichée dans vos annonces et votre profil.",
    "pictureFieldTitle": "Ajouter une image du logo de l'entreprise",
    "title": "Informations du profil",
    "firstNameFieldLabel-public": "Prénom",
    "firstNameFieldPlaceholder-public": "Prénom",
    "lastNameFieldLabel-public": "Nom",
    "lastNameFieldPlaceholder-public": "Nom",
    "phoneFieldLabel-public": "Numéro de téléphone (optionnel)",
    "pictureFieldSubtitle-public": "La photo de profil augmente la confiance entre membres",
    "pictureFieldTitle-public": "Ajouter une photo de profil",
    "title-public": "Vos informations personnelles"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "de Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "Vous venez de contribuer à enrichir le catalogue de <strong>Partage Agricole</strong> ! \n\nVous pouvez modifier vos offres à tout moment dans votre centre de partage."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "En offrant vos objets, vous encouragez même les horticulteur·trice·s les plus timides à demander."
      }
    }
  }
}
